import { DraggableModal } from '../DraggableModal';
import { CreditData, UserRole } from '../../services/api.types';
import { formatMoney } from '../../utils/formatters';
import dayjs from 'dayjs';
import { useAppSelector } from '../../hooks';
import { translateCreditReason } from '../../utils/translate-enums';

interface CreditDetailsModalProps {
  open: boolean;
  selectedCredit: CreditData;
  onClose: () => void;
}

export const CreditDetailsModal = ({
  open,
  onClose,
  selectedCredit,
}: CreditDetailsModalProps) => {
  const user = useAppSelector((state) => state.user);
  const isAdminOrEmployee =
    user?.role === UserRole.ADMIN || user?.role === UserRole.EMPLOYEE;

  return (
    <DraggableModal title={'Detalhes do crédito'} open={open} onClose={onClose}>
      <div className="flex flex-col gap-0">
        <p>
          <span>Responsável (recebedor): </span>
          <b className="ml-1">{selectedCredit.receiverName}</b>
        </p>

        <p>
          <span>Valor: </span>
          <b className="ml-1">{formatMoney(selectedCredit.value, true)}</b>
        </p>

        <p>
          <span>Saldo após transação: </span>
          <b className="ml-1">
            {formatMoney(selectedCredit.currentBalance, true)}
          </b>
        </p>

        <p>
          <span>Motivo: </span>
          <b className="ml-1">{translateCreditReason(selectedCredit.reason)}</b>
        </p>

        <p>
          <span>Data de criação: </span>
          <b className="ml-1">
            {dayjs(selectedCredit.createdAt).format('DD/MM/YYYY [às] HH:MM')}
          </b>
        </p>

        {isAdminOrEmployee && selectedCredit.giverName && (
          <p>
            <span>Crédito criado por: </span>
            <b className="ml-1">{selectedCredit.giverName}</b>
          </p>
        )}

        <p>
          <span>Descrição: </span>
          <b className="ml-1">{selectedCredit.description}</b>
        </p>
      </div>
    </DraggableModal>
  );
};
